import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { MonitoreoProfesionalesCreationContent } from './components/MonitoreoProfesionalesCreationContent';

export default function MonitoreoProfesionalesCreation() {

    return (
        <MainContent
            component={<MonitoreoProfesionalesCreationContent />}
            titulo={`Alta y modificación de Profesionales`}
            noBackground
            tableMaxWidth
            mainContentWhite
        />
    );

};
